import Title from 'pages/Reports/sections/Upload/Title/Title';

export default Title;
